import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import {
  successSystemContent,
  type SuccessSystemTopic,
} from '@backrs_ui/grow-ui/src/pages/SuccessSystem/successSystem.content';

const { overview, lifeAspirations, fundamentals, bigDecisions, trackProgression } =
  successSystemContent;

const topicDetail = (topic: SuccessSystemTopic): string =>
  `${topic.title}: ${topic.body}\nWhy it matters: ${topic.whyItMatters}`;

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: overview.title,
    description:
      'Overview of the Backrs Success System and its map: Life Aspirations, Fundamentals, Big Decisions, and Track Progression.',
    detail: overview.description.join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: lifeAspirations.group.title,
    description: lifeAspirations.group.subtitle,
    detail: topicDetail(lifeAspirations.lifeBlueprint),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: fundamentals.group.title,
    description: 'The Four Unlocks to Success and knowing your strengths.',
    detail: [
      `${fundamentals.fourUnlocks.title}: ${fundamentals.fourUnlocks.body}`,
      ...fundamentals.fourUnlocks.unlocks.map(
        (unlock) => `- ${unlock.name}: ${unlock.description}`,
      ),
      topicDetail(fundamentals.knowYourStrengths),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: bigDecisions.group.title,
    description: bigDecisions.group.subtitle,
    detail: bigDecisions.topics.map(topicDetail).join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: trackProgression.group.title,
    description: 'Investing where it counts and the calendar of milestones.',
    detail: [trackProgression.investWhereItCounts, trackProgression.calendarOfMilestones]
      .map(topicDetail)
      .join('\n'),
  });
};
